import { createStart } from '@tanstack/react-start';
import { otelMiddleware } from './middleware/otel';

// Global middleware for all TanStack server functions.
// otelMiddleware wraps every server function in an Effect span so SQL
// queries and auth calls are linked to their parent request trace.
export const startInstance = createStart(() => ({
  functionMiddleware: [otelMiddleware],
}));
